import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Ico from './iconBox';

// import aboutBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class About extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
            {/* End Main Top */}
            {/* Start Top Search */}
            
            {/* End Top Search */}
            {/* Start All Title Box */}
            
            {/* End All Title Box */}
            {/* Start About Page  */}





          <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
            <div className="container">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item" style={{fontWeight:"800",color:"#008071"}}><a >About Us</a></li>
              </ol>
            </div>{/* End .container */}
          </nav>{/* End .breadcrumb-nav */}



        

<div className='container' style={{margin : "30px 10px"}}>
            <div className='row'  >
            <div className="col-lg-8 col-sm-12" style={{margin  :"auto"}}>


         <center>
         <h1 style={{fontSize:"34px",fontWeight:"800",margin:"0px",color:"#008071"}}>DubaiPlantStore.com</h1>

         {/* <h1 style={{fontSize:"24px",fontWeight:"600",margin:"0px"}}>Premier Destination for Fashion Designer & Bridal Dress in Lahore Pakistan</h1> */}

<p style={{    color: "black"}}>
  
Welcome to <b>Dubai Plant Store</b> , your ultimate destination for premium-quality indoor and outdoor plants in the UAE! 🌱 We are passionate about bringing nature closer to you by offering a diverse selection of plants, from low-maintenance houseplants to exotic rare species, vibrant outdoor garden plants, and specially curated plant bundles for homes and offices.
<br />
<br />
At <b>Dubai Plant Store</b> , we believe that plants don’t just beautify spaces—they create a healthier, more refreshing environment. Whether you’re looking for air-purifying plants, flowering plants, succulents, cacti, bonsai trees, or large decorative plants to enhance your living or workspace, we have something for everyone.

<br />
<br />
<h1 style={{fontSize:"34px",fontWeight:"800",margin:"0px",color:"#008071"}}>💚 Why Choose Us? </h1>
✅ <b> Premium Quality:</b> Hand-picked, healthy plants sourced from the best nurseries
<br />
✅ <b> Wide Variety:</b> Indoor, outdoor, air-purifying, and rare exotic plants available
<br />
✅ <b> Fast & Safe Delivery:</b> Delivered fresh to your doorstep across Dubai & UAE
<br />
✅ <b> Affordable Prices:</b> Competitive rates without compromising on quality
<br />
✅ <b> Plant Care Guidance:</b> Expert tips to keep your plants thriving

<br />
<br />
🌍 Whether you’re a plant enthusiast, home gardener, or business owner, our expert team is here to help you select the perfect plants for your space. Elevate your surroundings with the natural beauty of plants—shop with us today and bring greenery into your life! 🌿✨

</p>
<br />


          
         </center>
        
           
          
            </div>
            </div>
            </div>


            <div className="container icon-boxes-section">
                <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2">

                  <div>
                 
                 < Ico/>
                

                  </div>

                </div>
                </div>



            {/* </div> */}
        
          </div>
        )
    }
}

export default About;